import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["workspace_id", "user_id"],
  _excluded2 = ["token"],
  _excluded3 = ["role_id"],
  _excluded4 = ["role_id"],
  _excluded5 = ["workspace_id"],
  _excluded6 = ["skill_id"],
  _excluded7 = ["skill_id"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { CrudAPIClient, createWorkspacedResourceUrlGetter, APIClient } from '../misc/APIClient';
export function createIamAPI(opts) {
  return {
    workspaces: new WorkspaceAPI(opts),
    members: new MemberAPI(opts),
    auth: new AuthAPI(opts),
    users: new UserAPI(opts),
    permissions: new PermissionAPI(opts),
    skills: new SkillAPI(opts),
    roles: new RoleAPI(opts),
    domains: new DomainAPI(opts),
    teams: new TeamAPI(opts),
    teamMembers: new TeamMemberAPI(opts),
    teamRoles: new TeamRoleAPI(opts),
    invitations: new InvitationAPI(opts),
    impersonation: new ImpersonationAPI(opts),
    termsOfUse: new TermsOrUseAPI(opts),
    translations: new TranslationAPI(opts),
    userData: new UserDataAPI(opts)
  };
}
export var WorkspaceAPI = /*#__PURE__*/function (_CrudAPIClient) {
  function WorkspaceAPI() {
    var _this;
    _classCallCheck(this, WorkspaceAPI);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WorkspaceAPI, [].concat(args));
    _this.prefix = '/v3/workspaces';
    return _this;
  }
  _inherits(WorkspaceAPI, _CrudAPIClient);
  return _createClass(WorkspaceAPI, [{
    key: "cloneWorkspace",
    value: function cloneWorkspace(id, data) {
      return this.client.post("/v3/workspaces/".concat(id, "/clone"), data).then(this._data);
    }
  }, {
    key: "listSecrets",
    value: function listSecrets(id) {
      return this.client.get("/v3.1/workspaces/".concat(id, "/secrets"));
    }
  }, {
    key: "createSecret",
    value: function createSecret(id, data) {
      return this.client.post("/v3.1/workspaces/".concat(id, "/secrets"), data);
    }
  }, {
    key: "updateSecret",
    value: function updateSecret(data) {
      return this.client.patch("/v3.1/workspaces/secrets", data);
    }
  }, {
    key: "deleteSecret",
    value: function deleteSecret(id) {
      return this.client.delete("/v3.1/workspaces/secrets/".concat(id));
    }
  }]);
}(CrudAPIClient);
export var PermissionAPI = /*#__PURE__*/function (_CrudAPIClient2) {
  function PermissionAPI() {
    var _this2;
    _classCallCheck(this, PermissionAPI);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _callSuper(this, PermissionAPI, [].concat(args));
    _this2.prefix = '/v3/permissions';
    return _this2;
  }
  _inherits(PermissionAPI, _CrudAPIClient2);
  return _createClass(PermissionAPI);
}(CrudAPIClient);
export var SkillAPI = /*#__PURE__*/function (_CrudAPIClient3) {
  function SkillAPI() {
    var _this3;
    _classCallCheck(this, SkillAPI);
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    _this3 = _callSuper(this, SkillAPI, [].concat(args));
    _this3.getResourceUrl = createWorkspacedResourceUrlGetter('skills', '/v3');
    return _this3;
  }
  _inherits(SkillAPI, _CrudAPIClient3);
  return _createClass(SkillAPI);
}(CrudAPIClient);
export var RoleAPI = /*#__PURE__*/function (_CrudAPIClient4) {
  function RoleAPI() {
    var _this4;
    _classCallCheck(this, RoleAPI);
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    _this4 = _callSuper(this, RoleAPI, [].concat(args));
    _this4.getResourceUrl = createWorkspacedResourceUrlGetter('roles', '/v3');
    return _this4;
  }
  _inherits(RoleAPI, _CrudAPIClient4);
  return _createClass(RoleAPI, [{
    key: "canBackToClassicRoles",
    value: function canBackToClassicRoles(workspaceId) {
      return this.client.get("/v3/workspaces/".concat(workspaceId, "/can-back-classic-roles")).then(this._data);
    }
  }]);
}(CrudAPIClient);
export var DomainAPI = /*#__PURE__*/function (_CrudAPIClient5) {
  function DomainAPI() {
    var _this5;
    _classCallCheck(this, DomainAPI);
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }
    _this5 = _callSuper(this, DomainAPI, [].concat(args));
    _this5.prefix = '/v3/domains';
    return _this5;
  }
  _inherits(DomainAPI, _CrudAPIClient5);
  return _createClass(DomainAPI);
}(CrudAPIClient);
export var SkillTagAPI = /*#__PURE__*/function (_APIClient) {
  function SkillTagAPI() {
    _classCallCheck(this, SkillTagAPI);
    return _callSuper(this, SkillTagAPI, arguments);
  }
  _inherits(SkillTagAPI, _APIClient);
  return _createClass(SkillTagAPI, [{
    key: "find",
    value: function find(query) {
      return this.client.get("/v3/skill-tags", {
        params: query
      }).then(this._data);
    }
  }, {
    key: "create",
    value: function create(data) {
      return this.client.post("/v3/skill-tags", data).then(this._data);
    }
  }, {
    key: "update",
    value: function update(id, data) {
      return this.client.patch("/v3/skill-tags/".concat(id), data).then(this._data);
    }
  }, {
    key: "delete",
    value: function _delete(id) {
      return this.client.delete("/v3/skill-tags/".concat(id)).then(this._data);
    }
  }]);
}(APIClient);
export var TranslationAPI = /*#__PURE__*/function (_APIClient2) {
  function TranslationAPI() {
    _classCallCheck(this, TranslationAPI);
    return _callSuper(this, TranslationAPI, arguments);
  }
  _inherits(TranslationAPI, _APIClient2);
  return _createClass(TranslationAPI, [{
    key: "getAll",
    value: function getAll(workspaceId) {
      return this.client.get("/v3/translations/".concat(workspaceId)).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "upsert",
    value: function upsert(data) {
      return this.client.put("/v3/translations", data).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "remove",
    value: function remove(id) {
      return this.client.delete("/v3/translations/".concat(id)).then(function (response) {
        return response.data;
      });
    }
  }]);
}(APIClient);
export var TermsOrUseAPI = /*#__PURE__*/function (_CrudAPIClient6) {
  function TermsOrUseAPI() {
    _classCallCheck(this, TermsOrUseAPI);
    return _callSuper(this, TermsOrUseAPI, arguments);
  }
  _inherits(TermsOrUseAPI, _CrudAPIClient6);
  return _createClass(TermsOrUseAPI, [{
    key: "getLatest",
    value:
    /**
     * @typedef {Object} TermsOfUseGetResult
     * @property {string} id
     * @property {string} markup
     * @property {string} date_created
     * @property {string} date_modified
     *
     * @returns {Promise<TermsOfUseGetResult>}
     */
    function getLatest() {
      return this.client.get('/v3/terms-of-use').then(this._data);
    }

    /**
     *
     * @param {string} workspaceId
     * @returns {Promise<TermsOfUseGetResult>}
     */
  }, {
    key: "getLatestForWorkspace",
    value: function getLatestForWorkspace(workspaceId) {
      return this.client.get("/v3/terms-of-use/".concat(workspaceId)).then(this._data);
    }

    /**
     * Checks if the current member has accepted the
     * latest Terms Of Use for the current workspace
     *
     * @typedef {Object} TermsAcceptanceCheckResult
     * @property {boolean} accepted
     *
     * @param {string} workspaceId
     * @returns {Promise<TermsAcceptanceCheckResult>}
     */
  }, {
    key: "checkAcceptance",
    value: function checkAcceptance(workspaceId) {
      return this.client.post('/v3/terms-acceptance', {
        workspace_id: workspaceId
      }).then(this._data);
    }

    /**
     * @template T
     * @typedef {Object} CursorPaged<T>
     * @property {string} cursor
     * @property {Array<T>} data
     *
     * @param {string} workspaceId
     * @returns {CursorPaged<TermsAcceptanceAcceptResult>}
     */
  }, {
    key: "getAcceptances",
    value: function getAcceptances(workspaceId) {
      var expandTous = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this.client.get("/v3/terms-acceptance/".concat(workspaceId), {
        params: _objectSpread({}, expandTous && {
          'expand[]': 'tou'
        })
      }).then(this._data);
    }

    /**
     *
     * @typedef {Object} TermsAcceptanceAcceptResult
     * @property {string} tou_id
     * @property {string} workspace_id
     * @property {string} user_id
     * @property {string} accepted_at
     *
     * @param {string} workspaceId
     * @returns {Promise<TermsAcceptanceAcceptResult>}
     */
  }, {
    key: "acceptLatest",
    value: function acceptLatest(workspaceId) {
      return this.client.post('/v3/terms-acceptance/accept', {
        workspace_id: workspaceId
      }).then(this._data);
    }
  }]);
}(CrudAPIClient);
export var ImpersonationAPI = /*#__PURE__*/function (_APIClient3) {
  function ImpersonationAPI() {
    _classCallCheck(this, ImpersonationAPI);
    return _callSuper(this, ImpersonationAPI, arguments);
  }
  _inherits(ImpersonationAPI, _APIClient3);
  return _createClass(ImpersonationAPI, [{
    key: "impersonate",
    value: function impersonate(payload) {
      return this.client.post('/v3/impersonation', payload).then(this._data);
    }
  }]);
}(APIClient);
export var TeamAPI = /*#__PURE__*/function (_CrudAPIClient7) {
  function TeamAPI() {
    _classCallCheck(this, TeamAPI);
    return _callSuper(this, TeamAPI, arguments);
  }
  _inherits(TeamAPI, _CrudAPIClient7);
  return _createClass(TeamAPI, [{
    key: "getResourceUrl",
    value:
    /**
     * Gets the URL to use based on the method.
     *
     * @param {*} id
     * @param {*} data
     * @param {*} params
     * @param {*} method
     */
    function getResourceUrl(id, data) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var method = arguments.length > 3 ? arguments[3] : undefined;
      switch (method) {
        case 'find':
          return "/v3/workspaces/".concat(params.workspace_id, "/teams");
        case 'get':
          return typeof id === 'string' ? "/v3/teams/".concat(id) : "/v3/workspaces/".concat(id.workspace_id, "/teams/").concat(id.team_id);
        case 'create':
          return "/v3/teams";
        default:
          return "/v3/teams/".concat(id);
      }
    }

    /**
     * Change the avatar of a team.
     *
     * @param {*} params
     * @param {*} file
     */
  }, {
    key: "changeAvatar",
    value: function changeAvatar(params, file) {
      var formData = new window.FormData();
      formData.append('file', file);
      return this.client.put("".concat(this.getResourceUrl(params), "/avatar"), formData).then(this._data);
    }
  }]);
}(CrudAPIClient);
export var TeamMemberAPI = /*#__PURE__*/function (_CrudAPIClient8) {
  function TeamMemberAPI() {
    _classCallCheck(this, TeamMemberAPI);
    return _callSuper(this, TeamMemberAPI, arguments);
  }
  _inherits(TeamMemberAPI, _CrudAPIClient8);
  return _createClass(TeamMemberAPI, [{
    key: "getResourceUrl",
    value:
    /**
     * Gets the URL to use based on the method.
     *
     * @param {*} id
     * @param {*} data
     * @param {*} params
     * @param {*} method
     */
    function getResourceUrl(id, data) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var method = arguments.length > 3 ? arguments[3] : undefined;
      var enc = encodeURIComponent;
      switch (method) {
        case 'find':
          return "/v3/teams/".concat(params.team_id, "/team-members");
        case 'getMany':
          return "/v3/team-members/id-query";
        case 'create':
          return "/v3/team-members";
        default:
          // `id` should be an object.
          return "/v3/teams/".concat(id.team_id, "/team-members/").concat(enc(id.user_id));
      }
    }
  }, {
    key: "getTeamMembersForWorkspaceMemberByPublicId",
    value: function () {
      var _getTeamMembersForWorkspaceMemberByPublicId = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var workspace_id, user_id, params, url;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              workspace_id = _ref.workspace_id, user_id = _ref.user_id, params = _objectWithoutProperties(_ref, _excluded);
              url = "/v3.1/workspaces/".concat(workspace_id, "/members/").concat(user_id, "/team-members");
              return _context.abrupt("return", this.client.get(url, {
                params: params
              }).then(this._data));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTeamMembersForWorkspaceMemberByPublicId(_x) {
        return _getTeamMembersForWorkspaceMemberByPublicId.apply(this, arguments);
      }
      return getTeamMembersForWorkspaceMemberByPublicId;
    }()
    /**
     * Updates a team member by public id.
     *
     * @param {{ user_id: string, team_id: string }} params
     * @param {*} data
     */
  }, {
    key: "updateByPublicId",
    value: function updateByPublicId(params, data) {
      return this.client.patch("/v3.1/teams/".concat(params.team_id, "/team-members/").concat(params.user_id), data).then(this._data);
    }

    /**
     * Creates a team member for exising or new member user.
     * There might come more data if the member doesn't exist... like name, phone and more...
     *
     * @param {{ user_id: string, team_id: string, team_role: string, workspace_id: string }} data
     */
  }, {
    key: "createByPublicId",
    value: function createByPublicId(data) {
      return this.client.post('/v3.1/team-members', data);
    }

    /**
     * Deletes a team member by public id.
     *
     * @param {{ user_id: string, team_id: string }} params
     */
  }, {
    key: "deleteByPublicId",
    value: function deleteByPublicId(params) {
      return this.client.delete("/v3.1/teams/".concat(params.team_id, "/team-members/").concat(params.user_id));
    }

    /**
     * Get many team members using public id.
     *
     * @param {{user_id: string, team_id: string}[]} payload
     */
  }, {
    key: "getManyByPublicId",
    value: function getManyByPublicId(payload) {
      return this.client.post('/v3.1/team-members/id-query', payload).then(this._data);
    }
  }]);
}(CrudAPIClient);
export var TeamRoleAPI = /*#__PURE__*/function (_CrudAPIClient9) {
  function TeamRoleAPI() {
    _classCallCheck(this, TeamRoleAPI);
    return _callSuper(this, TeamRoleAPI, arguments);
  }
  _inherits(TeamRoleAPI, _CrudAPIClient9);
  return _createClass(TeamRoleAPI, [{
    key: "getResourceUrl",
    value:
    /**
     * Gets the URL to use based on the method.
     *
     * @param {*} id
     * @param {*} data
     * @param {*} params
     * @param {*} method
     */
    function getResourceUrl(id, data) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var method = arguments.length > 3 ? arguments[3] : undefined;
      switch (method) {
        case 'find':
          return "/v3/team-roles";
        case 'getMany':
          return "/v3/team-roles/id-query";
        case 'create':
          return "/v3/team-roles";
        default:
          return "/v3/team-roles/".concat(id);
      }
    }
  }]);
}(CrudAPIClient);
export var InvitationAPI = /*#__PURE__*/function (_CrudAPIClient10) {
  function InvitationAPI() {
    _classCallCheck(this, InvitationAPI);
    return _callSuper(this, InvitationAPI, arguments);
  }
  _inherits(InvitationAPI, _CrudAPIClient10);
  return _createClass(InvitationAPI, [{
    key: "getResourceUrl",
    value:
    /**
     * Gets the URL to use based on the method.
     *
     * @param {*} id
     * @param {*} data
     * @param {*} params
     * @param {*} method
     */
    function getResourceUrl(id, data) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var method = arguments.length > 3 ? arguments[3] : undefined;
      switch (method) {
        case 'find':
        case 'create':
          return "/v3/invitations";
        case 'findPending':
          return '/v3/invitationsPending';
        default:
          return "/v3/invitations/".concat(id);
      }
    }

    /**
     * Gets pending invitations
     * @param {*} token
     */
  }, {
    key: "findPending",
    value: function findPending(params) {
      return this.client.get(this.getResourceUrl(null, null, {}, 'findPending'), {
        params: params
      }).then(this._data);
    }

    /**
     * Accepts an invitation
     * @param {*} token
     */
  }, {
    key: "accept",
    value: function accept(_ref2) {
      var token = _ref2.token,
        payload = _objectWithoutProperties(_ref2, _excluded2);
      return this.client.post(this.getResourceUrl(token, payload, {}, 'accept'), payload).then(this._data);
    }
  }]);
}(CrudAPIClient);
export var MemberAPI = /*#__PURE__*/function (_CrudAPIClient11) {
  function MemberAPI() {
    _classCallCheck(this, MemberAPI);
    return _callSuper(this, MemberAPI, arguments);
  }
  _inherits(MemberAPI, _CrudAPIClient11);
  return _createClass(MemberAPI, [{
    key: "getResourceUrl",
    value:
    /**
     * This one is a little complex, because most of the time, `id` is a { workspace_id, user_id }
     * object, and when finding, it's using `params.workspace_id`.
     *
     * TODO: use the fourth param, `method` and switch on it. See TeamAPI.
     *
     * @param {*} id
     * @param {*} data
     * @param {*} params
     */
    function getResourceUrl(id, data, params) {
      var _ref3 = params || {},
        workspace_id = _ref3.workspace_id;
      if (!id && workspace_id) {
        if (!data) {
          // This is likely a Find query
          return "/v3/workspaces/".concat(workspace_id, "/members");
        }
        return "/v3/workspaces/".concat(workspace_id);
      }
      if (id === 'id-query') {
        return "/v3/members/id-query";
      }
      if (typeof id === 'string') {
        return "/v3/members/".concat(id);
      }
      if (!id) {
        return "/v3/members";
      }
      return "/v3/workspaces/".concat(id.workspace_id, "/members/").concat(id.user_id);
    }

    /**
     * Change the avatar of a user by public id.
     *
     * @param {*} params
     * @param {*} file
     */
  }, {
    key: "changeAvatarByPublicId",
    value: function changeAvatarByPublicId(params, file) {
      var formData = new window.FormData();
      formData.append('file', file);
      return this.client.put("/v3.1/workspaces/".concat(params.workspace_id, "/members/").concat(params.user_id, "/avatar"), formData).then(this._data);
    }
  }, {
    key: "addRoleByPublicId",
    value: function addRoleByPublicId(_ref4) {
      var role_id = _ref4.role_id,
        params = _objectWithoutProperties(_ref4, _excluded3);
      return this.client.post("/v3.1/workspaces/".concat(params.workspace_id, "/members/").concat(params.user_id, "/roles"), {
        role_id: role_id
      }).then(this._data);
    }

    /**
     * Adds a role to a member.
     */
  }, {
    key: "removeRoleByPublicId",
    value: function removeRoleByPublicId(_ref5) {
      var role_id = _ref5.role_id,
        params = _objectWithoutProperties(_ref5, _excluded4);
      return this.client.delete("/v3.1/workspaces/".concat(params.workspace_id, "/members/").concat(params.user_id, "/roles/").concat(role_id)).then(this._data);
    }
  }, {
    key: "search",
    value: function search(_ref6) {
      var workspace_id = _ref6.workspace_id,
        query = _objectWithoutProperties(_ref6, _excluded5);
      return this.client.get("/v3/workspaces/".concat(workspace_id, "/members/search"), {
        params: query
      }).then(this._data);
    }

    /**
     * Adds a skill to a member by public id.
     */
  }, {
    key: "addSkillByPublicId",
    value: function addSkillByPublicId(_ref7) {
      var skill_id = _ref7.skill_id,
        params = _objectWithoutProperties(_ref7, _excluded6);
      return this.client.post("/v3.1/workspaces/".concat(params.workspace_id, "/members/").concat(params.user_id, "/skills"), {
        skill_id: skill_id
      }).then(this._data);
    }

    /**
     * Removes a skill from a member by public id..
     */
  }, {
    key: "removeSkillByPublicId",
    value: function removeSkillByPublicId(_ref8) {
      var skill_id = _ref8.skill_id,
        params = _objectWithoutProperties(_ref8, _excluded7);
      return this.client.delete("/v3.1/workspaces/".concat(params.workspace_id, "/members/").concat(params.user_id, "/skills/").concat(skill_id)).then(this._data);
    }

    /**
     * Updates a workspace member.
     *
     * @param {*} data
     * @param params
     */
  }, {
    key: "updateByPublicId",
    value: function updateByPublicId(params, data) {
      return this.client.patch("/v3.1/workspaces/".concat(params.workspace_id, "/members/").concat(params.user_id), data).then(this._data);
    }
  }]);
}(CrudAPIClient);
export var UserAPI = /*#__PURE__*/function (_CrudAPIClient12) {
  function UserAPI() {
    var _this6;
    _classCallCheck(this, UserAPI);
    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }
    _this6 = _callSuper(this, UserAPI, [].concat(args));
    _this6.prefix = '/v3/users';
    return _this6;
  }
  _inherits(UserAPI, _CrudAPIClient12);
  return _createClass(UserAPI, [{
    key: "getUserWorkspaceMembershipsByPublicId",
    value: function getUserWorkspaceMembershipsByPublicId(userId, query) {
      return this.client.get("/v3.1/users/".concat(userId, "/workspace-memberships"), {
        params: query
      }).then(this._data);
    }
  }, {
    key: "requestPasswordReset",
    value: function requestPasswordReset(email, workspaceId) {
      return this.client.post("".concat(this.getResourceUrl(), "/reset-password-request"), {
        email: email,
        workspace_id: workspaceId
      }).then(this._data);
    }
  }, {
    key: "getResetPasswordRequestById",
    value: function getResetPasswordRequestById(id) {
      return this.client.get("".concat(this.getResourceUrl(), "/reset-password-request/").concat(id)).then(this._data);
    }
  }, {
    key: "resetPassword",
    value: function resetPassword(id, password) {
      return this.client.patch("".concat(this.getResourceUrl(), "/reset-password-request/").concat(id), {
        password: password
      }).then(this._data);
    }
  }, {
    key: "lookupPrivateIds",
    value: function lookupPrivateIds(ids) {
      return this.client.post("/v3/internal-ops/user-private-id", ids).then(this._data);
    }
  }, {
    key: "lookupPublicIds",
    value: function lookupPublicIds(ids) {
      return this.client.post("/v3/internal-ops/user-public-id", ids).then(this._data);
    }
  }, {
    key: "logout",
    value: function logout() {
      return this.client.post("".concat(this.getResourceUrl(), "/logout"));
    }
  }, {
    key: "getByPublicId",
    value: function getByPublicId(userPublicId) {
      return this.client.get("/v3.1/users/".concat(userPublicId)).then(this._data);
    }
  }]);
}(CrudAPIClient);
export var AuthAPI = /*#__PURE__*/function (_APIClient4) {
  function AuthAPI() {
    var _this7;
    _classCallCheck(this, AuthAPI);
    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }
    _this7 = _callSuper(this, AuthAPI, [].concat(args));
    _this7.prefix = '/v3/auth';
    return _this7;
  }
  _inherits(AuthAPI, _APIClient4);
  return _createClass(AuthAPI, [{
    key: "authenticate",
    value: function authenticate() {
      return this.client.post(this.prefix).then(this._data);
    }
  }, {
    key: "enrollMFA",
    value: function enrollMFA() {
      return this.client.post("/v3/auth/enroll-mfa").then(this._data);
    }
  }, {
    key: "signUpUser",
    value: function signUpUser(payload) {
      return this.client.post("/v3/auth/signup", payload).then(this._data);
    }
  }]);
}(APIClient);
export var InternalOpsAPI = /*#__PURE__*/function (_APIClient5) {
  function InternalOpsAPI() {
    _classCallCheck(this, InternalOpsAPI);
    return _callSuper(this, InternalOpsAPI, arguments);
  }
  _inherits(InternalOpsAPI, _APIClient5);
  return _createClass(InternalOpsAPI, [{
    key: "lookupPrivateIds",
    value: function lookupPrivateIds(ids) {
      return this.client.post("/v3/internal-ops/user-private-id", ids).then(this._data);
    }
  }]);
}(APIClient);
export var UserDataAPI = /*#__PURE__*/function (_CrudAPIClient13) {
  function UserDataAPI() {
    _classCallCheck(this, UserDataAPI);
    return _callSuper(this, UserDataAPI, arguments);
  }
  _inherits(UserDataAPI, _CrudAPIClient13);
  return _createClass(UserDataAPI, [{
    key: "getByPublicId",
    value: function getByPublicId(userPublicId) {
      return this.client.get("/v3/users/".concat(userPublicId, "/user-data")).then(this._data);
    }
  }, {
    key: "updateByPublicId",
    value: function updateByPublicId(userPublicId, payload) {
      return this.client.put("/v3/users/".concat(userPublicId, "/user-data"), payload);
    }
  }]);
}(CrudAPIClient);
//# sourceMappingURL=API.js.map
